import React from 'react';

/*
 * Media icons for the hero video, from Google Material Symbols (Apache 2.0), weight 300, to match
 * the icons in the Figma design. Local because the design-system icon registry has no media icons
 * (only `close`). All decorative: the owning button carries the accessible name.
 */

interface IconProps {
  size?: number;
}

const svgProps = (size: number) =>
  ({
    'aria-hidden': true,
    fill: 'currentColor',
    height: size,
    viewBox: '0 -960 960 960',
    width: size,
  } as const);

export const PlayIcon = ({ size = 24 }: IconProps) => (
  <svg {...svgProps(size)}>
    <path d="M320-200v-560l440 280-440 280Z" />
  </svg>
);

export const CloseIcon = ({ size = 24 }: IconProps) => (
  <svg {...svgProps(size)}>
    <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
  </svg>
);

export const PauseIcon = ({ size = 24 }: IconProps) => (
  <svg {...svgProps(size)}>
    <path d="M560-200v-560h160v560H560Zm-320 0v-560h160v560H240Z" />
  </svg>
);

export const ReplayIcon = ({ size = 24 }: IconProps) => (
  <svg {...svgProps(size)}>
    <path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z" />
  </svg>
);

export const SoundOnIcon = ({ size = 24 }: IconProps) => (
  <svg {...svgProps(size)}>
    <path d="M560-131v-82q90-26 145-100t55-168q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 127-78 224.5T560-131ZM120-360v-240h160l200-200v640L280-360H120Zm440 40v-322q47 22 73.5 66t26.5 96q0 51-26.5 94.5T560-320ZM400-606l-86 86H200v80h114l86 86v-252Z" />
  </svg>
);

export const SoundOffIcon = ({ size = 24 }: IconProps) => (
  <svg {...svgProps(size)}>
    <path d="M792-56 671-177q-25 16-53 27.5T560-131v-82q14-5 27.5-10t25.5-12L480-368v208L280-360H120v-240h128L56-792l56-56 736 736-56 56Zm-8-232-58-58q17-31 25.5-65t8.5-70q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 53-14.5 102T784-288ZM650-422l-90-90v-130q47 22 73.5 66t26.5 96q0 15-2.5 29.5T650-422ZM480-592 376-696l104-104v208Zm-80 238v-94l-72-72H200v80h114l86 86Z" />
  </svg>
);
